import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from "@material-ui/core/Tooltip";
import {Select,FormControl} from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
const CssSelect = withStyles({
  root: {
    width: "100%",
    color:'#fff',
    fontSize:'1rem',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    background:'none',
    //lineHeight: 1.5,
    //select:{color:'#fff'},
    //margin: "12px 0",
    'label + &': {
      color:'#fff',
    },

    'input + &' : {
      color:'#fff'
    } ,

    // "& label.MuiInputLabel-root": {
    //   color: "#8987A2",
    //   //transform: "translate(16px, 15px) scale(1)",

    //   "&.Mui-error": {
    //     color: "#F87777"
    //   }
    // },
    '&:before' : {
      borderBottom: '1px solid #fff'
    },

    "& label.Mui-focused": {
      color: "#8987A2"
    },

    "& .MuiFilledInput-root": {
      background: "#F6F6FB",
      borderRadius: "4px",
      color: '#3C3C56',
     },

     "& .MuiSelect-icon": {
      
      color: '#3C3C56',
     }
  },
  //root,select,filled,outlined,selectMenu,disabled,icon,iconOpen,iconFilled,iconOutlined,nativeInput.
  select:{
    background:'none'
  },
  filled:{
    background:'none',
    borderColor:'#fff'
  },
  nativeInput: {
    borderColor:'#fff'
  },  
  icon:{
    color:'#fff'
  },
  '&:before' : {
    borderBottom: '1px solid #fff'
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    background:'none'
  },
  // margin: {
  //   margin: theme.spacing(1)
  // }
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

// const StyledTextField = styled(TextField)({
//   "& label, & label.Mui-focused": {
//     color: "green"
//   }
// });

const StyledTextField = withStyles({
  root: {
    //background: "white",
    color:'rgba(36, 38, 42, 1)',
    margin:0,
    marginTop:0,
    padding:0,
   
    backgroundColor:'#fff',
    input:{
      color:'rgba(36, 38, 42, 1)',
      marginTop:0,
      padding:0,
    },

    "& .MuiInputBase-root" : {
      padding:5
    }
    
    /*"& :before" : {
      border: "none"
    },
    "& :after" : {
      "& :hover":{
        border: "none"
      }
    },
    "&:hover" : {
      border: "none"
    },
    "& :focus" : {
      border: "none"
    },
    "& .MuiInput-underline:after": {
      border: "none"
    },
   
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }*/
  }
})(TextField);

const StyledAutocomplete = withStyles({
  root: {
    //background: "white",
    padding:0,
    width:270,
    background: '#fff',//'#BCBBD0',
    opacity: 0.39,
    borderRadius: 4,
    color:'rgba(36, 38, 42, 1)', 
    "& .MuiAutocomplete-popupIndicator": {
      color: "rgba(137, 135, 162, 1)"
    }, 
    "& .MuiAutocomplete-clearIndicatorDirty": {
      color: "rgba(137, 135, 162, 1)"
    }, 
    /*"& .MuiInput-underline:after": {
      border: "none"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }*/
  }
})(Autocomplete);


export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <StyledAutocomplete
      //style={{width:'100%', padding:'0 16px'}}
      options =  {props.data.map(option => option.name )}
      //getOptionLabel ={(option) => option.name || ''}
      //getOptionSelected = {(option, value) =>  option.name === value}
      value = {props.value}
      id ={props.id}
      MenuProps={{variant: "menu"}}
      onChange = {(e, newValue) => props.onChange(e,newValue, props.data.map(option => option.name ).indexOf(newValue))}
      //inputValue = {props.value}
      renderInput={(params) => <StyledTextField {...params} variant="outlined" /*label={props.label}*/ margin="normal" />}
    //renderOption ={}
    />
  );
}
